module.exports = __webpack_public_path__ + "img/pijltjes-secundaire-button-blauw.ba918e6b66b59d2d85385aaa5b1015dc.svg";